"use client"

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Alert, AlertDescription } from "@/components/ui/alert"
import { Gem, ExternalLink, Info, Key } from "@/lib/icons"
import { useRouter } from "next/navigation"
import { useTranslations } from "next-intl"

interface DoujinsPremiumModalProps {
  isOpen: boolean
  onClose: () => void
}

export function DoujinsPremiumModal({ isOpen, onClose }: DoujinsPremiumModalProps) {
  const t = useTranslations("doujinsPremiumModal")
  const router = useRouter()

  const handleGoToSources = () => {
    onClose()
    router.push('/sources')
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <Gem className="h-5 w-5 text-amber-500" />
            <DialogTitle>{t("premiumContent")}</DialogTitle>
          </div>
          <DialogDescription>
            {t("thisGalleryRequiresAPremiumSubscriptionOn")}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <Alert>
            <Info className="h-4 w-4" />
            <AlertDescription className="text-sm space-y-2">
              <p>{t("toAccessThisPremiumContentYouNeedTo")}</p>
              <ol className="list-decimal list-inside space-y-1 ml-2">
                <li>{t("createAPremiumAccountOn")} <strong>{t("doujinsCom")}</strong></li>
                <li>{t("addYourDoujinsComCredentialsInGoonruSSou")}</li>
              </ol>
            </AlertDescription>
          </Alert>

          <Alert variant="default" className="bg-muted/50">
            <Gem className="h-4 w-4" />
            <AlertDescription className="text-xs text-muted-foreground">
              <strong>{t("important")}</strong> {t("aGoonruMembershipDoesNotGrantAccessToDou")}
            </AlertDescription>
          </Alert>

          <div className="flex flex-col gap-2">
            <Button
              onClick={() => window.open('https://doujins.com', '_blank')}
              className="w-full"
            >
              <ExternalLink className="h-4 w-4 mr-2" />
              {t("visitDoujinsCom")}
            </Button>
            
            <Button
              onClick={handleGoToSources}
              variant="outline"
              className="w-full"
            >
              <Key className="h-4 w-4 mr-2" />
              {t("addCredentials")}
            </Button>

            <Button
              onClick={onClose}
              variant="ghost"
              className="w-full"
            >
              {t("close")}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
